<div style="background-color: #dedede;line-height: 0px;">
  <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
                  font-size: 12px;margin-bottom: 0 !important;">
    <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ol>
</div>

<mat-toolbar>
  <h6 class="show-title">{{pageTitle}}</h6>
  <button *ngIf="showLogin" class="more-btn-custom" mat-raised-button (click)="addDevice(deviceTypeID, deviceTypeName)">
    <i class="material-icons icon-layout-custom">add_circle</i>
    &nbsp;
    Add New
  </button>
</mat-toolbar>

<div class="add_device_type form_outer" fxLayoutAlign="center center" fxLayout="column" style="padding: 16px;">
  <form [formGroup]="uForm" (ngSubmit)="saveDevice()">
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text" placeholder="Device Serial &nbsp; *" matInput formControlName="device_name" id="device_name">
        <!-- <mat-placeholder class="placeholder">Device Serial &nbsp; *</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text" placeholder="Mac address &nbsp; *" matInput formControlName="mac_address" id="mac_address">
        <!-- <mat-placeholder class="placeholder">Mac address &nbsp; *</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div *ngIf="editCase" class="address_fields form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <mat-select placeholder="Select client" formControlName="client_value" (ngModelChange)="selectedClient($event)">
          <mat-option *ngFor="let clients of clientList;let idx = index;" [value]="clients.id">
            {{clients.company_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <span style="font-size: 12px;color: #da2a02;">{{msgLimit}}</span>
    </div>
    <div *ngIf="showLogin" class="btn-box text-center">
      <button mat-raised-button style="border-radius: 50px;" type="submit" [disabled]="!uForm.valid">Save</button>
    </div>
    <div *ngIf="showUpdate" class="btn-box text-center">
      <button mat-raised-button style="border-radius: 50px;" type="button" (click)="update()"
        [disabled]="makeUpdatedisable">
        Update
      </button>
    </div>
  </form>
</div><div style="background-color: #dedede;line-height: 0px;">
  <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
                  font-size: 12px;margin-bottom: 0 !important;">
    <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ol>
</div>

<mat-toolbar>
  <h6 class="show-title">{{pageTitle}}</h6>
  <button *ngIf="showLogin" class="more-btn-custom" mat-raised-button (click)="addDevice(deviceTypeID, deviceTypeName)">
    <i class="material-icons icon-layout-custom">add_circle</i>
    &nbsp;
    Add New
  </button>
</mat-toolbar>

<div class="add_device_type form_outer" fxLayoutAlign="center center" fxLayout="column" style="padding: 16px;">
  <form [formGroup]="uForm" (ngSubmit)="saveDevice()">
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text" matInput formControlName="device_name" id="device_name">
        <!-- <mat-placeholder class="placeholder">Device Serial &nbsp; *</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="text" matInput formControlName="mac_address" id="mac_address">
        <!-- <mat-placeholder class="placeholder">Mac address &nbsp; *</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div *ngIf="editCase" class="address_fields form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <mat-select placeholder="Select client" formControlName="client_value" (ngModelChange)="selectedClient($event)">
          <mat-option *ngFor="let clients of clientList;let idx = index;" [value]="clients.id">
            {{clients.company_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <span style="font-size: 12px;color: #da2a02;">{{msgLimit}}</span>
    </div>
    <div *ngIf="showLogin" class="btn-box text-center">
      <button mat-raised-button style="border-radius: 50px;" type="submit" [disabled]="!uForm.valid">Save</button>
    </div>
    <div *ngIf="showUpdate" class="btn-box text-center">
      <button mat-raised-button style="border-radius: 50px;" type="button" (click)="update()"
        [disabled]="makeUpdatedisable">
        Update
      </button>
    </div>
  </form>
</div>